// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"22":"7b337e","38":"db25c5","48":"f46a36","474":"01961f"}[chunkId] + ".css";
};